import Axios from 'axios';
import * as cookies from './Cookies';

//
// const baseURL = 'https://sevimli-api.thinkland.uz/api/';
const baseURL = 'http://sevimli-lavash.uz/api/';
const url = {
    me: 'me/',
    auth: 'token/',
    authRefresh: 'token/refresh/',
    dashboard: 'dashboard/',
    products: 'products/',
    categories: 'category/',
    categoriesGood: 'good-category/',
    orders: 'orders/',
    ordersHistory: 'postorders/',
    ordersHistoryTotal: 'postorders//total_sum/',
    statusOrders: 'statusorder/',
    users: 'users/',
    delivery_tariffs: 'delivery_tariffs/',
    customers: 'customers/',
    calls: 'calls/',
    campaigns: 'campaigns/',
    documents: 'document/',
    vendors: 'vendors/',
    branches: 'branches/',
    survey:'questions/',
    sms: 'sms/',
    mod:'modifications/',
    branch:'branches/',
    classification:'classification/',
    goods:'good/',
    goods_category:'good-category/',
    unit:"unit-type/",
    session:'session/',
    income:'income/',
    revision:'revision/',
    balance_of_goods:'balance-of-goods/'
};

const axios = Axios.create({
    baseURL,
    validateStatus: function(status) {
        return status >= 200 && status <= 503;
    }
});

axios.interceptors.request.use(function(config) {
    const token = cookies.get('jwt');

    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

// AUTH
export function login(data) {
    return axios.post(url.auth, data);
}

export function refreshToken(data) {
    return axios.post(url.authRefresh, data);
}

export function getMe() {
    return axios.get(url.me);
}

export function updateMe(data) {
    return axios.put(url.me, data);
}

// DASHBOARD
export function dashboardGet(page = 1) {
    return axios.get(`${url.dashboard}?page=${page}`);
}
//MODERATION
export function moderationGet(page = 1, pageSize = 20) {
    return axios.get(`${url.mod}?page=${page}&page_size=${pageSize}`);
}
//MODERATION
export function branchGet(page = 1, pageSize = 20) {
    return axios.get(`${url.branch}?page=${page}&page_size=${pageSize}`);
}
// VENDORS
export function vendorsGet(page = 1, pageSize = 20) {
    return axios.get(`${url.vendors}?page=${page}&page_size=${pageSize}`);
}

export function vendorsGetByCategoryId(vendorsId, page = 1, pageSize = 20, is_active = true) {
    return axios.get(`${url.vendors}?page=${page}&page_size=${pageSize}&category=${vendorsId}&is_active=${true}`);
}
export function vendorsGetAll(id) {
    return axios.get(`${url.vendors}?category=${id}`);
}

export function vendorsGetById(id) {
    return axios.get(`${url.vendors}${id}/`);
}

export function vendorsPost(data) {
    return axios.post(url.vendors, data);
}

export function vendorsPut(id, data) {
    return axios.put(`${url.vendors}${id}/`, data);
}

export function vendorsDelete(id, data) {
    return axios.delete(`${url.vendors}${id}/`, { data });
}














// PRODUCTS
export function productGet(page = 1, category) {
    return axios.get(`${url.products}?page=${page}&page_size=20${category ? `&category=${category}`:''}`);
}

export function productGetByCategoryId(categoryId, page = 1, pageSize = 20, is_active = true) {
    return axios.get(`${url.products}?page=${page}&page_size=${pageSize}&category=${categoryId}&is_active=${true}`);
}
export function classGetByCategoryId(parentId, page = 1, pageSize = 20, is_active = true) {
    return axios.get(`${url.classification}?page=${page}&page_size=${pageSize}&parent=${parentId}&is_active=${true}`);
}

export function productGetAll(id) {
    return axios.get(`${url.products}?category=${id}`);
}

export function productGetById(id) {
    return axios.get(`${url.products}${id}/`);
}

export function productPost(data) {
    return axios.post(url.products, data);
}
export function modificationPost(data) {
    return axios.post(url.mod, data);
}

export function productPut(id, data) {
    return axios.put(`${url.products}${id}/`, data);
}
export function modificationPut(id, data) {
    return axios.put(`${url.mod}${id}/`, data);
}

export function productDelete(id, data) {
    return axios.delete(`${url.products}${id}/`, { data });
}
export function moderationDelete(id, data) {
    return axios.delete(`${url.mod}${id}/`, { data });
}
export function branchDelete(id, data) {
    return null
}

//goods of balance
export function goodsBalanceGet(page = 1, category) {
    return axios.get(`${url.goods}?page=${page}&page_size=20${category ? `&category_id=${category}`:''}`);
}
export  function goodsBalansGetByCategoryId(id, page = 1, pageSize = 20, is_active = true) {
    return axios.get(`${url.balance_of_goods}?page=${page}&page_size=${pageSize}&category=${id}&is_active=${is_active}`);
}
export function goodsBalansGetById(id) {
    return axios.get(`${url.balance_of_goods}${id}/`);
}





// GOODS
export function goodsGet(page = 1, category) {
    return axios.get(`${url.goods}?page=${page}&page_size=20${category ? `&category_id=${category}`:''}`);
}

export function goodsGetByCategoryId(categoryId, page = 1, pageSize = 20, is_active = true) {
    return axios.get(`${url.goods_category}?page=${page}&page_size=${pageSize}&category=${categoryId}&is_active=${true}`);
}
export function classGoodsGetByCategoryId(parentId, page = 1, pageSize = 100, is_active = true) {
    return axios.get(`${url.goods_category}?page=${page}&page_size=${pageSize}&parent=${parentId}&is_active=${true}`);
}

export function goodsGetAll(id) {
    return axios.get(`${url.goods_category}?category=${id}`);
}

export function goodsGetById(id) {
    return axios.get(`${url.goods_category}${id}/`);
}

export function goodsPost(data) {
    return axios.post(url.goods_category, data);
}

export function goodsPut(id, data) {
    return axios.put(`${url.goods_category}${id}/`, data);
}

export function goodsDelete(id, data) {
    return axios.delete(`${url.goods_category}${id}/`, { data });
}


//Good
// GOODS

export function goodGetAll(id) {
    return axios.get(`${url.goods}?category=${id}`);
}

export function goodGetById(id) {
    return axios.get(`${url.goods}${id}/`);
}

export function goodPost(data) {
    return axios.post(url.goods, data);
}

export function goodPut(id, data) {
    return axios.put(`${url.goods}${id}/`, data);
}

export function goodDelete(id, data) {
    return axios.delete(`${url.goods}${id}/`, { data });
}
// export function moderationDelete(id, data) {
//     return axios.delete(`${url.mod}${id}/`, { data });
// }
// export function branchDelete(id, data) {
//     return null
// }

// ORDERS
export function orderGet(page = 1, pageSize = 30) {
    return axios.get(`${url.orders}?page=${page}&page_size=${pageSize}`);
}

export function orderGetById(id) {
    return axios.get(`${url.orders}${id}/`);
}

export function orderPost(data) {
    return axios.post(url.orders, data);
}

export function orderPut(id, data) {
    return axios.put(`${url.orders}${id}/`, data);
}

export function orderUpdateStatus(id, data) {
    return axios.post(`${url.orders}${id}/change_status/`, data);
}

export function orderDelete(id, data) {
    return axios.delete(`${url.orders}${id}/`, { data });
}

// ORDERS HISTORY
export function orderHistoryGet(page = 1, pageSize = 30, params) {
    return axios.get(`${url.ordersHistory}?page=${page}&page_size=${pageSize}`, { params: params });
}
export function orderHistoryTotalGet(page = 1, pageSize = 20, params) {
    return axios.get(`${url.ordersHistoryTotal}?page=${page}&page_size=${pageSize}`, { params: params });
}

// STATUS ORDERS
export function statusOrderGet(page = 1, pageSize = 30) {
    return axios.get(`${url.statusOrders}?page=${page}&page_size=${pageSize}`);
}

export function statusOrderGetById(id) {
    return axios.get(`${url.statusOrders}${id}/`);
}

export function statusOrderPost(data) {
    return axios.post(url.statusOrders, data);
}

export function statusOrderPut(id, data) {
    return axios.put(`${url.statusOrders}${id}/`, data);
}

export function statusOrderDelete(id, data) {
    return axios.delete(`${url.statusOrders}${id}/`, { data });
}

export function surveyGet(page = 1, pageSize = 30) {
    return axios.get(`${url.survey}`);
}
// CATEGORIES
export function categoryGoodGet(page = 1, pageSize =30) {
    return axios.get(`${url.categoriesGood}?page=${page}&page_size=${pageSize}`);
}
export function categoryGet(page = 1, pageSize =30) {
    return axios.get(`${url.categories}?page=${page}&page_size=${pageSize}`);
}
export function catGet(parent, page = 1, pageSize =30) {
    return axios.get(`${url.classification}?${(!parent || parent===1) ? '':`&parent=${parent}`}`);
}

// CLASSIFICATION
export function classGet(parent, page = 1, pageSize =30) {
    return axios.get(`${url.classification}?${(!parent || parent===1) ? `&parent=1`:`&parent=${parent}`}`);
}

export function categoryGetById(id) {
    return axios.get(`${url.categories}${id}/`);
}

export function categoryPost(data) {
    return axios.post(url.categories, data);
}
export function classificationPost(data) {
    return axios.post(url.classification, data);
}

export function categoryPut(id, data) {
    return axios.put(`${url.categories}${id}/`, data);
}
export function classificationPut(id, data) {
    return axios.put(`${url.classification}${id}/`, data);
}

export function categoryDelete(id, data) {
    return axios.delete(`${url.categories}${id}/`, { data });
}
export function classificationDelete(id, data) {
    return axios.delete(`${url.classification}${id}/`, { data });
}

// SESSION
export function sessionGet(page = 1, pageSize = 20, search) {
    return axios.get(`${url.session}?page=${page}&page_size=${pageSize}`,{params: search});
}
export function sessionPost(data) {
    return axios.post(url.session, data);
}
export function sessionDelete(id) {
    return axios.delete(`${url.session}${id}/`);
}
export function sessionPut(id, data) {
    return axios.put(`${url.session}${id}/`, data);
}
//INCOME
export function incomeGet(page = 1, pageSize = 20) {
    return axios.get(`${url.income}?page=${page}&page_size=${pageSize}`);
}
export function classincomeGet(good, page = 1, pageSize =30) {
    return axios.get(`${url.good}?${(!good || good===1) ? '':`&good=${good}`}`);
}
export function incomePost(data) {
    return axios.post(url.income, data);
}
export function incomeDelete(id) {
    return axios.delete(`${url.income}${id}/`);
}
export function incomePut(id, data) {
    return axios.put(`${url.income}${id}/`, data);
}
//REVISION
export function revisionGet(page = 1, pageSize = 20) {
    return axios.get(`${url.revision}?page=${page}&page_size=${pageSize}`);
}
export function classrevisionGet(good, page = 1, pageSize =30) {
    return axios.get(`${url.good}?${(!good || good===1) ? '':`&good=${good}`}`);
}
export function revisionPost(data) {
    return axios.post(url.revision, data);
}
export function revisionDelete(id) {
    return axios.delete(`${url.revision}${id}/`);
}
export function revisionPut(id, data) {
    return axios.put(`${url.revision}${id}/`, data);
}
// // GOODS
export function goodsGetByItem(category, page = 1) {
    return axios.get(`${url.goods_category}?page=${page}&page_size=20${category ? `&category=${category}`:''}`);}

/// GOODS_CATEGORY
export function goodsCatGet(page = 1, pageSize = 20, search) {
    return axios.get(`${url.goods_category}?page=${page}&page_size=${pageSize}`,{params: search});
}
export function goodsCatPost(data) {
    return axios.post(url.goods_category, data);
}
export function goodsCatPut(id, data) {
    return axios.put(`${url.goods_category}${id}/`, data);
}
export function goodsCatDelete(id) {
    return axios.delete(`${url.goods_category}${id}/`);
}

/// UNIT TYPE
export function unitGet(page = 1, pageSize = 20, search) {
    return axios.get(`${url.unit}?page=${page}&page_size=${pageSize}`,{params: search});
}
export function unitPost(data) {
    return axios.post(url.unit, data);
}
export function unitPut(id, data) {
    return axios.put(`${url.unit}${id}/`, data);
}
export function unitDelete(id) {
    return axios.delete(`${url.unit}${id}/`);
}

// USERS
export function userGet(page = 1, pageSize = 20, search) {
    return axios.get(`${url.users}?page=${page}&page_size=${pageSize}`,{params: search});
}

export function courierGet(page = 1, pageSize = 20) {
    return axios.get(`${url.users}?page=${page}&page_size=${pageSize}&type=courier`);
}

export function tariffGet(page = 1, pageSize = 20) {
    return axios.get(`${url.delivery_tariffs}?page=${page}&page_size=${pageSize}`);
}

export function userGetById(id) {
    return axios.get(`${url.users}${id}/`);
}

export function userPost(data) {
    return axios.post(url.users, data);
}

export function userPut(id, data) {
    return axios.put(`${url.users}${id}/`, data);
}

export function userDelete(id) {
    return axios.delete(`${url.users}${id}/`);
}

// CUSTOMERS
export function customerGet(page = 1, pageSize = 20) {
    return axios.get(`${url.customers}?page=${page}&page_size=${pageSize}`);
}

export function customerGetById(id) {
    return axios.get(`${url.customers}${id}/`);
}

export function customerPost(data) {
    return axios.post(url.customers, data);
}

export function customerPut(id, data) {
    return axios.put(`${url.customers}${id}/`, data);
}

export function customerDelete(id) {
    return axios.delete(`${url.customers}${id}/`);
}

// CALSS
export function callGet(page = 1, pageSize = 20) {
    return axios.get(`${url.calls}?page=${page}&page_size=${pageSize}`);
}

export function callGetById(id) {
    return axios.get(`${url.calls}${id}/`);
}

export function callPost(data) {
    return axios.post(url.calls, data);
}

export function callPut(id, data) {
    return axios.put(`${url.calls}${id}/`, data);
}

export function callDelete(id) {
    return axios.delete(`${url.calls}${id}/`);
}
export function surveyDelete(id) {
    return axios.delete(`${url.survey}${id}/`);
}

// CAMPAIGN
export function campaignGet(page = 1, pageSize = 20) {
    return axios.get(`${url.campaigns}?page=${page}&page_size=${pageSize}`);
}

export function campaignGetById(id) {
    return axios.get(`${url.campaigns}${id}/`);
}

export function campaignPost(data) {
    return axios.post(url.campaigns, data);
}

export function campaignPut(id, data) {
    return axios.put(`${url.campaigns}${id}/`, data);
}

export function campaignDelete(id) {
    return axios.delete(`${url.campaigns}${id}/`);
}

// DOCUMENT
export function documentGet(page = 1, pageSize = 20) {
    return axios.get(`${url.documents}?page=${page}&page_size=${pageSize}`);
}

export function documentGetById(id) {
    return axios.get(`${url.documents}${id}/`);
}

export function documentPost(data) {
    return axios.post(url.documents, data);
}
export function classPost(data) {
    return axios.post(url.classification, data);
}

export function documentPut(id, data) {
    return axios.put(`${url.documents}${id}/`, data);
}

export function documentDelete(id) {
    return axios.delete(`${url.documents}${id}/`);
}

export function getBranches() {
    return axios.get(`${url.branches}`);
}

// SMS
export function smsGet(page = 1, pageSize = 20) {
    return axios.get(`${url.sms}?page=${page}&page_size=${pageSize}`);
}

export function smsPost(data) {
    return axios.post(url.sms, data);
}
